
import { statusSimulacao } from "./configSimulacao";
import styles from "./styles.module.css";

export function getResultDiscountMessage(value, corTema) {
  return (
  <span className={styles.msgDiscount}>
    Você pode economizar até {' '}
    <strong style={{color: corTema }}>
      {parseFloat(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}
    </strong> {' '}
    por ano
  </span>
  );
}

export function getResultFailMessage(status) {
  let messages = {};
  messages[statusSimulacao.empty_inputs] = '';
  messages[statusSimulacao.regiao_nao_atendida] = 'Região não atendida no momento';
  messages[statusSimulacao.sem_consumo_minimo] = 'Consumo insuficiente para obter descontos';
  messages[statusSimulacao.sem_estoque] = 'Região sem estoque disponível';
  messages[statusSimulacao.tipo_pf_pj_indisponivel] = 'Tipo de contratação não disponível no momento';
  messages[statusSimulacao.zero_value] = 'Informe o valor da conta';
  return <span className={styles.msgDiscountError}>{messages?.[status] ?? ''}</span>
}